<div class="mention-textarea-container">
    <div #textarea contenteditable="true" (input)="onInput($event)" (keydown)="onKeydown($event)"
        class="form-control editable-div" [attr.placeholder]="placeholder"></div>

    <div *ngIf="showUserDropdown" class="user-mention-dropdown">
        <div *ngIf="userSearchLoading" class="dropdown-item text-muted">
            Chargement...
        </div>
        <div *ngFor="let user of userSearchResults; let i = index" class="dropdown-item"
            [class.active]="i === selectedUserIndex" (mousedown)="selectUser(user); $event.preventDefault();"
            (mouseenter)="selectedUserIndex = i">
            {{ user.fullName }} ({{ user.email }})
        </div>
        <div *ngIf="!userSearchLoading && userSearchResults.length === 0" class="dropdown-item text-muted">
            Aucun utilisateur trouvé
        </div>
    </div>
</div>